import type { DeviceDTO } from "../../../api/contract";
import type { DeviceTaskItem } from "../../api";

export function formatRelative(iso: string | null): string {
  if (!iso) return "—";
  const t = new Date(iso).getTime();
  if (!Number.isFinite(t)) return "—";
  const diff = Date.now() - t;
  if (diff < 60_000) return "ora";
  if (diff < 60 * 60_000) return `${Math.floor(diff / 60_000)}m fa`;
  if (diff < 24 * 60 * 60_000) return `${Math.floor(diff / (60 * 60_000))}h fa`;
  return `${Math.floor(diff / (24 * 60 * 60_000))}g fa`;
}

export function deviceStateKey(d: DeviceDTO): "online" | "offline" | "revoked" {
  if (d.revokedAt) return "revoked";
  if (d.online) return "online";
  return "offline";
}

export function getTaskName(t: DeviceTaskItem): string {
  return [t.payload.cognome, t.payload.nome].filter(Boolean).join(" ") || t.payload.rawName || `Task #${t.id}`;
}
